export default class Configuration {
  /**
   * Create new configuration and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
